import { Grid } from "@material-ui/core";
import BillCustomTable from "./BillCustomTable";
import { returnJalali } from "../../utils/TimeUtils";
import Num2persian from "num2persian";
const BillFooter = ({ info, type }) => {
  console.log(info);
  const textPrice = [`${Num2persian(Math.round(info.bill_price))} ریال`];
  const payDetails = info.other_information.hasOwnProperty("pay_details")
    ? info.other_information.pay_details
    : "";
  const paymentInfo = [info.bill_serial, ""];
  const unitsInfo = [
    `نرخ هر (${
      info.bill_water_meter.water_meter_type_info.water_meter_tag_info
        .water_meter_tag_name === "برق"
        ? "کیلووات"
        : "مترمکعب"
    })`,
    info.bill_water_meter.water_meter_type_info.water_meter_tag_info
      .water_meter_tag_name === "برق"
      ? "4548"
      : "__",
  ];
  const paymentDeadline = [
    returnJalali(info.payment_dead_line),
    Math.round(info.bill_price).toLocaleString(),
  ];
  return (
    <>
      <Grid container xs={12} sm={12} md={12} lg={12}>
        <Grid item xs={4} sm={4} md={4} lg={4}>
          <BillCustomTable
            header={["بهای واحد مصرف (ریال)"]}
            body={[unitsInfo]}
            hcolspan={"2"}
            type={type}
          />
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4}>
          <div style={{ margin: "0 6px" }}>
            <BillCustomTable
              header={["شناسه قبض", "شناسه پرداخت "]}
              body={[paymentInfo]}
              hcolspan={"1"}
              type={type}
            />
          </div>
        </Grid>
        <Grid item xs={4} sm={4} md={4} lg={4}>
          <BillCustomTable
            header={["مهلت پرداخت", "مبلغ قابل پرداخت (ریال)"]}
            body={[paymentDeadline]}
            hcolspan={"1"}
            type={type}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <div
            style={{
              border: "1px solid #555",
              padding: "3px",
              margin: "3px 0",
            }}
          >
            مبلغ به حروف : <span style={{ padding: "0 5px" }}>{textPrice}</span>
          </div>
          <div style={{ textAlign: "center" }}>{payDetails}</div>
        </Grid>
      </Grid>
    </>
  );
};
export default BillFooter;
